import { useState } from 'react'
import format from 'date-fns/format'
import isBefore from 'date-fns/is_before'
import parse from 'date-fns/parse'
import differenceInDays from 'date-fns/difference_in_days'

const useExpiryHook = ({ data }) => {
  const [isRenewing, setIsRenewing] = useState(false)

  const generateExpiryText = (hasExpired, days, endDate) => {
    if (hasExpired) {
      return `Your membership has expired on ${endDate}.`
    }

    if (days > 29) {
      const months = (days / 30).toFixed()
      return `Your membership expires in ${months} month${
        parseInt(months) > 1 ? 's' : ''
      }.`
    }

    if (days === 0) {
      return 'Your membership expires today.'
    }

    return 'Your membership expires in less than a month.'
  }

  let expiry = {
    show: false,
  }

  if (data && data.membership) {
    const normalizedEndDate = parse(
      data.membership.endDate.match(/(.+[^Z])Z?$/)[1]
    ) // regex to exclude "Z" character at the end if it exists

    const daysLeft = differenceInDays(
      normalizedEndDate,
      new Date(new Date().setHours(0, 0, 0, 0))
    )

    const hasExpired = isBefore(normalizedEndDate, new Date())
    const endDate = format(normalizedEndDate, 'DD/MM/YYYY')

    if (typeof daysLeft === 'number') {
      expiry = {
        expiring: daysLeft <= 90,
        expiryDate: endDate,
        expiryText: generateExpiryText(hasExpired, daysLeft, endDate),
        hasExpired,
      }
    }
  }

  return {
    ...expiry,
    isRenewing,
    onClickRenewButton: () => setIsRenewing(true),
  }
}

export default useExpiryHook
